<template>
  <div
    class="spa-status-message container"
  >
    <div
      class="spa-status-message-wrapper"
      :class="`--${type}`"
      role="status"
    >
      <span
        v-if="icon"
        :class="`icon-${icon}`"
        aria-hidden="true"
      />
      <span>{{ message }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SpaStatusMessage',
    props: {
      type: {
        type: String,
        default: 'info',
        validator(value) {
          return ['success', 'info', 'error'].includes(value)
        }
      },
      icon: {
        type: String,
        default: '',
      },
      message: {
        type: String,
        default: ''
      }
    }
  }
</script>
